module.exports = __webpack_public_path__ + "static/media/profile.e22902e8.jpg";